import {specialPathForNewRefs} from "../const/utils";
import {SharedToolsService} from "../services/shared-tools.service";

export function isSpecialPathForNewRefs(sharedToolsService: SharedToolsService): boolean {
  return specialPathForNewRefs.indexOf(sharedToolsService.returnObjectSwitchRefId()) !== -1;
}
